import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import axios from "axios";
import VueAxios from "vue-axios";
import functioncryto from "@/services/encrypt.js";
import "sweetalert2/dist/sweetalert2.min.css";
import vuetify from "./plugins/vuetify";
import myscss from "./assets/scss/myscss.scss";
import VueSocketIO from "vue-socket.io";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import VueSignaturePad from "vue-signature-pad";
import VueApexCharts from "vue-apexcharts";
import ScrollLoader from "vue-scroll-loader";
import InfiniteLoading from "vue-infinite-loading";
import "@/assets/font/Sarabun-normal";
import "@/assets/font/NotoSerifThai-normal";
// import VueMask from "v-mask";
import VueTheMask from "vue-the-mask";
import VueFriendlyIframe from "vue-friendly-iframe";

// import Toasted from 'vue-toasted';

Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(VueSignaturePad);
Vue.use(VueApexCharts);
// Vue.use(VueMask);
Vue.use(VueTheMask);
Vue.component("apexchart", VueApexCharts);
Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC8t40PLvvJxAeOqTe9q3MDkh--6q_Kve8",
    libraries: "places",
  },
});
Vue.use(InfiniteLoading, {
  slots: {
    noMore: "",
  },
});
Vue.component("GmapCluster", GmapCluster);
Vue.use(InfiniteLoading);
Vue.use(ScrollLoader);

var urls = require("url");
var urls_socket = process.env.VUE_APP_BACKEND_URL;
var socketURL = urls.parse(urls_socket, true);
var url_socket = "https://" + socketURL.host;
var url_path_socket = socketURL.pathname + "/socket.io/";
Vue.use(
  new VueSocketIO({
    debug: false,
    connection: url_socket,
    options: { path: url_path_socket, transports: ["websocket", "polling"] },
  })
);
Vue.use(VueFriendlyIframe);
// Vue.use(Toasted,{
//   duration: 1500
// });

axios.interceptors.request.use(
  function (config) {
    // console.log("🚀 ~ config:", config);
    if (config.url.indexOf(process.env.VUE_APP_BACKEND_URL) > -1) {
      // console.log("🚀 ~ config api in .env:", config)
      // if (config.data && config.data.data) {
      //   config.data.data = functioncryto.encrypt(config.data.data);
      // }
      // if (config.url) {
      //   const [baseUrl, queryString] = config.url.split("?");
      //   if (queryString) {
      //     // แปลง query string เป็น object
      //     const params = new URLSearchParams(queryString);

      //     // เข้ารหัสแต่ละค่าใน query string
      //     for (let [key, value] of params.entries()) {
      //       params.set(key, encodeURIComponent(functioncryto.encrypt(value)));
      //     }

      //     // รวม URL ที่ถูกเข้ารหัสกลับเข้าไปใน config.url
      //     config.url = `${baseUrl}?${params.toString()}`;
      //   }
      // }
      if (sessionStorage.access_token) {
        if (!config.headers.Authorization && !config.headers.authorization) {
          config.headers.Authorization = `Bearer ${sessionStorage.access_token}`;
        }
      }
      return config;
    } else {
      // console.log("🚀 ~ config api other .env:", config)
      return config;
    }
  },
  function (error) {
    console.log("🚀 ~ error axios.interceptors.request:", error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    const data = response.data.data;

    let resBack = {};

    if (typeof data === "string" && data !== undefined) {
      var decodedata = functioncryto.decrypt(data);

      resBack = {
        ...response,
        data: {
          ...response.data,
          data: decodedata,
        },
      };
      return resBack;
    }

    return response;
  },
  function (error) {
    console.log("🚀 ~ error axios.interceptors.response:", error);
    if (
      error.response &&
      !error.config.url.includes("/main") &&
      !error.config.url.includes("/consent") &&
      !error.config.url.includes("/management/register-line") &&
      !error.config.url.includes("/management/profile") &&
      (error.response.data.message == "one_authorization not found" ||
        error.response.data.message == "Token is require." ||
        error.response.data.message == "Invalid token.")
    ) {
      window.location.href = `${process.env.VUE_APP_LOCAL_HOME}page-authorization-not-found`;
    } else {
      return Promise.reject(error);
    }
    // return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  myscss,
  render: (h) => h(App),
}).$mount("#app");
